import * as init from './Init'
import * as nextHandler from "./NextHandler";
import ServletUrlUtil from '../../util/urlUtil/ServletUrlUtil'

export let getStoreData = () => {
    const store = init.getStore();
    return {
        accountStatus: store.getters['AccountStoreV2/accountStatus'],
        paymentTrial: store.getters['AccountStoreV2/paymentTrial']
    }
};

/**
 * Memebershipとお試し状況によりURLの末尾部分を振り分ける
 * 例えばMINIの場合、 ${path}/mini/trial または ${path}/mini/normal のどちらかにリダイレクトする
 */
export function validateWithTrial(next, path) {
    const storeData = getStoreData();
    const membership = storeData.accountStatus.membership;
    if(membership.isMini) {
        // TODO プリGET完了ページisShowPuriGetCompleteしか対応できてない
        const trialType = storeData.paymentTrial.isShowPuriGetComplete && storeData.paymentTrial.canTrial ? 'trial' : 'normal';
        nextHandler.nextReplace(next, `${path}/mini/${trialType}`)
    } else if (membership.isPremium) {
        nextHandler.nextReplace(next, `${path}/premium/normal`)
    } else {
        nextHandler.nextWithPageView(next, path)
    }
};

/**
 * ログインしているかの共通判定
 */
export function isLogin() {
    const storeData = getStoreData();
    const accountStatus = storeData.accountStatus;
    return !!accountStatus && !accountStatus.membership.isGuest;
}

export function requiredLogin(next){
    if(isLogin()){
        next();
    }else{
        location.href = new ServletUrlUtil().loginUrl();
    }
}

export function requiredNotLogin(next){
    if(isLogin()){
        location.href = new ServletUrlUtil().topUrl();
    }else{
        next();
    }
}
